import React from 'react'

function MortarboardIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M16.9993 30.6506L7.08268 25.2646V16.7605L1.41602 13.6423L16.9993 5.13818L32.5827 13.6423V24.9812H29.7493V15.2014L26.916 16.7605V25.2646L16.9993 30.6506ZM16.9993 18.8865L26.7035 13.6423L16.9993 8.3981L7.29518 13.6423L16.9993 18.8865ZM16.9993 27.4261L24.0827 23.5993V18.2487L16.9993 22.1465L9.91602 18.2487V23.5993L16.9993 27.4261Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default MortarboardIcon
